import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFacebook, faInstagram} from '@fortawesome/free-brands-svg-icons';
import styles from './footer-xsci.module.css'
import responsive from "./footer-xsci-responsive.module.css";
import {useTranslation} from "react-i18next";
import CompanySection from "./company-section";
import ServicesSection from "./services-section";
import ContactSection from "./contact-section";

const FooterComponent = () => {
    const {t, i18n} = useTranslation();


    return (
        <div className="container-fluid justify-content-center">
            <hr className="mx-0 px-0"/>
            <footer>
                <div className="row justify-content-around mb-0 pt-5 pb-0 ">
                    <div className=" col-11">
                        <div className="row justify-content-center">
                            <div className="col-md-3 col-12 font-italic align-items-center  mt-md-3 mt-4">
                                <h5>
                                    <span>
                                        <img src="/images/newLogo.webp" className="img-fluid  w-25 mb-1"/>
                                    </span>
                                </h5>
                                <p className={`mt-md-3 mt-2 ${styles.social}`}>
                                    <span>
                                        <a href="https://www.facebook.com/people/XSCI/61573466566374/"
                                            className={`${styles.follow_us_link} ${responsive.follow_us_link}`}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                                <FontAwesomeIcon icon={faFacebook}
                                                    style={{cursor: 'pointer', fontSize: '21px', margin: '5px 10px 5px 10px',
                                                        color: "darkturquoise"}}/>
                                        </a>
                                    </span>
                                    <span>
                                        <a href="https://instagram.com/xscisolutions"
                                           target="_blank"
                                           rel="noopener noreferrer">
                                                <FontAwesomeIcon icon={faInstagram}
                                                                 style={{cursor: 'pointer', fontSize: '21px', margin: '5px 10px 5px 10px',
                                                                     color: "darkturquoise"}}/>
                                        </a>
                                    </span>
                                </p>
                                <small className="copy-rights cursor-pointer">&#9400;{new Date().getFullYear()} XSCI
                                    inc.</small><br/>
                                <small>Copyright.All Rights Resered. </small>
                            </div>
                            <CompanySection/>
                            <ServicesSection/>
                            <ContactSection/>

                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default FooterComponent;